import styles from "./Marquee.module.css";
import { marqueeMessages } from "./marqueeData";

const Marquee = () => {
  return (
    <div className={styles.marqueeContainer}>
      <div className={styles.marqueeContent}>
        {marqueeMessages.map((msg, index) => (
          <span key={index} className={styles.message}>
            {msg}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
